// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#error[data-v-6ec65fb7]{-webkit-animation:linear;-webkit-animation-name:run;-webkit-animation-duration:2s}", ""]);
// Exports
module.exports = exports;
